import { useEffect, useMemo } from "react";

import { CsvIcon, DocIcon, PdfIcon, TxtIcon, XlsIcon } from "./Sources";

const ReadPdfModal = ({ readPdf, setReadPdf, readPdfText }) => {
  const isLink = readPdfText?.type === "link";

  const parsedContent = useMemo(() => {
    let contentStr = readPdfText?.content;
    if (typeof contentStr === "object" && contentStr !== null) {
      return JSON.stringify(contentStr, null, 2);
    }
    if (typeof contentStr !== "string") {
      return String(contentStr);
    }

    try {
      let cleaned = contentStr
        .replace(/<summary-cbb>[\s\S]*?<\/summary-cbb>/gi, "")
        .trim();

      if (cleaned.startsWith("```json"))
        cleaned = cleaned.replace(/^```json\n?/i, "");
      else if (cleaned.startsWith("```"))
        cleaned = cleaned.replace(/^```\n?/, "");
      if (cleaned.endsWith("```")) cleaned = cleaned.replace(/\n?```$/, "");
      cleaned = cleaned.trim();

      const parts = cleaned.split(/(===SHEET:.*?===)/);
      let resultStr = "";

      for (let i = 0; i < parts.length; i++) {
        let part = parts[i].trim();
        if (!part) continue;

        if (part.startsWith("===SHEET:")) {
          resultStr += part + "\n";
        } else {
          try {
            const parsed = JSON.parse(part);
            resultStr += JSON.stringify(parsed, null, 2) + "\n\n";
          } catch (e) {
            const firstBracket = part.indexOf("[");
            const lastBracket = part.lastIndexOf("]");
            if (
              firstBracket !== -1 &&
              lastBracket !== -1 &&
              lastBracket > firstBracket
            ) {
              const potentialJson = part.slice(firstBracket, lastBracket + 1);
              try {
                const parsed = JSON.parse(potentialJson);
                const formatted = JSON.stringify(parsed, null, 2);
                const before = part.slice(0, firstBracket).trim();
                const after = part.slice(lastBracket + 1).trim();
                if (before) resultStr += before + "\n";
                resultStr += formatted + "\n";
                if (after) resultStr += after + "\n";
                resultStr += "\n";
              } catch (err) {
                resultStr += part + "\n\n";
              }
            } else {
              resultStr += part + "\n\n";
            }
          }
        }
      }

      return resultStr.trim();
    } catch (e) {
      return contentStr;
    }
  }, [readPdfText?.content]);
  useEffect(() => {
    const mainMenuElement = document.querySelector(
      ".main-menu-ai-builder",
    ) as HTMLElement;
    const shortLeftColElement = document.querySelector(
      ".short-left-col",
    ) as HTMLElement;
    if (readPdf) {
      if (mainMenuElement) {
        mainMenuElement.setAttribute("style", "z-index: 0 !important;");
      }
      if (shortLeftColElement) {
        shortLeftColElement.setAttribute("style", "z-index: 0 !important;");
      }
    }
    return () => {
      if (mainMenuElement) {
        mainMenuElement.style.zIndex = "99";
      }
      if (shortLeftColElement) {
        shortLeftColElement.style.zIndex = "90";
      }
    };
  }, [readPdf]);

  return (
    <div
      className="modal-scroll createbot-modal read_pdf_modal"
      data-branding-protected="true"
    >
      <div className="createbot-container modal-responsive create-bot-landscape">
        <div className="add-wrk-container add-workflow-wrapper">
          <div className="workspace-dt ct-wrkspce align-center pd-20 flex items-center justify-center gap-10">
            {isLink ? (
              <div className="flex w-full flex-col items-center justify-center">
                <div className="flex w-full items-center gap-[4px]">
                  <span className="inline-flex h-[32px] w-[32px] items-center justify-center rounded-full">
                    <LinkIcon />
                  </span>
                  <h1 className="!inline truncate text-[16px] font-medium capitalize text-[#444]">
                    {" "}
                    {readPdfText?.title}
                  </h1>
                </div>
                <a
                  href={readPdfText?.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full truncate text-center underline"
                >
                  {readPdfText?.link}
                </a>
              </div>
            ) : (
              <div className="flex items-center gap-[5px]">
                {readPdfText?.title?.toLowerCase().endsWith(".pdf") ? (
                  <PdfIcon className={"h-[25px] w-[25px] flex-shrink-0"} />
                ) : readPdfText?.title?.toLowerCase().endsWith(".xlsx") ? (
                  <XlsIcon className={"h-[25px] w-[25px] flex-shrink-0"} />
                ) : readPdfText?.title?.toLowerCase().endsWith(".docx") ? (
                  <DocIcon className={"h-[25px] w-[25px] flex-shrink-0"} />
                ) : readPdfText?.title?.toLowerCase().endsWith(".txt") ? (
                  <TxtIcon className={"h-[25px] w-[25px] flex-shrink-0"} />
                ) : readPdfText?.title?.toLowerCase().endsWith(".csv") ? (
                  <CsvIcon className={"h-[25px] w-[25px] flex-shrink-0"} />
                ) : (
                  <PdfIcon className={"h-[25px] w-[25px] flex-shrink-0"} />
                )}
                <h1>
                  {readPdfText?.title?.includes(".")
                    ? readPdfText?.title?.split(".").slice(0, -1).join(".")
                    : readPdfText?.title}
                </h1>
              </div>
            )}
          </div>
          <div className="createbot-button no-mb p-relative">
            {/* <div className="grey-scrollbar pdftxt overflow-auto"> */}
            <p className="grey-scrollbar">
              <pre className="whitespace-pre-wrap text-left text-[14px] !leading-[130%] text-[#444]">
                {parsedContent}
              </pre>
            </p>
            {/* </div> */}
          </div>
          <div className="create-bot-footer flex-cnt no-m">
            <button
              onClick={() => {
                setReadPdf(false);
              }}
            >
              Done
            </button>
          </div>
        </div>
        <div
          className="close new-modal-close flex-cnt og-close"
          onClick={() => {
            setReadPdf(false);
          }}
        >
          <svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="#6D6D6D"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 1.00714L8.99286 0L5 3.99286L1.00714 0L0 1.00714L3.99286 5L0 8.99286L1.00714 10L5 6.00714L8.99286 10L10 8.99286L6.00714 5L10 1.00714Z"
              fill="#6D6D6D"
            ></path>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default ReadPdfModal;

const LinkIcon = () => (
  <svg
    className="fs-0"
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    viewBox="0 0 17 17"
    fill="none"
  >
    <g clipPath="url(#clip0_375_1563)">
      <mask
        id="mask0_375_1563"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={17}
        height={17}
      >
        <path d="M0.5 0.189697H16.5V16.1897H0.5V0.189697Z" fill="white" />
      </mask>
      <g mask="url(#mask0_375_1563)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6224 6.5897C11.6704 7.0929 11.7 7.6233 11.7 8.1897C11.7 8.40187 11.6157 8.60535 11.4657 8.75538C11.3157 8.90541 11.1122 8.9897 10.9 8.9897C10.6878 8.9897 10.4843 8.90541 10.3343 8.75538C10.1843 8.60535 10.1 8.40187 10.1 8.1897C10.1 7.6193 10.0688 7.0873 10.016 6.5897H6.9736C6.8624 7.6537 6.8616 8.7257 6.9704 9.7897H8.5C8.71217 9.7897 8.91566 9.87398 9.06569 10.024C9.21571 10.174 9.3 10.3775 9.3 10.5897C9.3 10.8019 9.21571 11.0054 9.06569 11.1554C8.91566 11.3054 8.71217 11.3897 8.5 11.3897H7.2328C7.608 13.0537 8.1944 14.1177 8.5008 14.5897C8.5008 14.5897 9.132 14.6001 9.2416 14.5913C9.45286 14.5776 9.66103 14.6475 9.82118 14.786C9.98133 14.9244 10.0806 15.1203 10.0976 15.3313C10.113 15.5428 10.0438 15.7518 9.9052 15.9123C9.76659 16.0728 9.56991 16.1717 9.3584 16.1873C9.2832 16.1929 8.5 16.1897 8.5 16.1897C4.0888 16.1897 0.5 12.6009 0.5 8.1897C0.5 3.7777 4.0888 0.189697 8.5 0.189697C12.9112 0.189697 16.5 3.7777 16.5 8.1897C16.5 8.4929 16.4712 8.7889 16.4368 9.0825C16.405 9.28727 16.2951 9.47176 16.1301 9.59718C15.9652 9.72261 15.758 9.7792 15.5522 9.75506C15.3464 9.73093 15.1579 9.62795 15.0265 9.46776C14.895 9.30758 14.8307 9.10267 14.8472 8.8961C14.8752 8.6633 14.9 8.4297 14.9 8.1897C14.9 7.6361 14.8216 7.1017 14.6896 6.5897H11.6224ZM8.4904 1.8185C8.1816 2.3033 7.6104 3.3633 7.2392 4.9897H9.7488C9.376 3.3633 8.8008 2.3033 8.4904 1.8185ZM2.3104 9.7897H5.3656C5.31565 9.25889 5.29029 8.72605 5.2896 8.1929C5.2896 7.6569 5.316 7.1225 5.3664 6.5897H2.3104C2.17258 7.11193 2.10188 7.64959 2.1 8.1897C2.102 8.7298 2.1727 9.26744 2.3104 9.7897ZM2.9656 11.3897C3.7556 12.7527 5.01883 13.7779 6.5152 14.2705C6.09835 13.3491 5.79014 12.3823 5.5968 11.3897H2.9656ZM5.5984 4.9897C5.79172 3.99634 6.10049 3.02897 6.5184 2.1073C5.02054 2.59955 3.75602 3.62546 2.9656 4.9897H5.5984ZM11.3896 4.9897H14.0336C13.2399 3.61904 11.9678 2.58995 10.4616 2.1001C10.8835 3.02344 11.195 3.99334 11.3896 4.9897Z"
          fill="#444"
        />
        <path
          d="M12.6783 15.3466L10.6383 10.8586C10.6047 10.7845 10.5944 10.7019 10.609 10.6218C10.6235 10.5417 10.6621 10.4679 10.7197 10.4104C10.7773 10.3528 10.851 10.3142 10.9311 10.2996C11.0112 10.2851 11.0938 10.2954 11.1679 10.329L15.6559 12.369C15.7248 12.4002 15.7835 12.4503 15.8251 12.5134C15.8667 12.5766 15.8896 12.6503 15.891 12.7259C15.8924 12.8015 15.8724 12.876 15.8332 12.9407C15.794 13.0054 15.7372 13.0577 15.6695 13.0914L14.2759 13.7874C14.1987 13.8263 14.1361 13.8892 14.0975 13.9666L13.4007 15.3602C13.367 15.4279 13.3147 15.4846 13.25 15.5238C13.1853 15.563 13.1109 15.5831 13.0352 15.5816C12.9596 15.5802 12.8859 15.5574 12.8228 15.5158C12.7596 15.4742 12.7095 15.4155 12.6783 15.3466Z"
          fill="#444"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_375_1563">
        <rect
          width={16}
          height={16}
          fill="white"
          transform="translate(0.5 0.189697)"
        />
      </clipPath>
    </defs>
  </svg>
);
